import React from 'react';
import { useTranslation } from 'react-i18next';

import { MenuItem, TextField } from '@material-ui/core';
import { LevelOfInvoiceEnumDto } from '.generated/api';

interface LevelOfInvoiceSelectProps {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  required?: boolean;
}
const LevelOfInvoiceSelect: React.FC<LevelOfInvoiceSelectProps> = (props) => {
  const { t } = useTranslation(['translations']);
  return (
    <TextField
      variant="outlined"
      fullWidth
      select
      label={t('labels.level_of_invoice')}
      name="levelOfInvoice"
      {...props}
    >
      <MenuItem value={LevelOfInvoiceEnumDto.ORGANIZATION}>
        {t('labels.organization')}
      </MenuItem>
      <MenuItem value={LevelOfInvoiceEnumDto.DEPARTMENT}>
        {t('labels.department')}
      </MenuItem>
    </TextField>
  );
};

export default LevelOfInvoiceSelect;
